import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Container,
  RightPanelContainer,
  WebContainer,
  KeyboardView,
  Scroll,
  Wrapper,
  Row,
  Card,
  CardBody
} from "app/NativeComponents/common";

import { Header } from "app/NativeComponents/snippets";
import { trackSegmentEvent } from "app/DealMachineCore/actions";

import {
  toggleCanPop,
  toggleDrawer,
  lockDrawer,
  mobileToggleDrawer,
  changeTab,
  appRedirect,
  checkIfOnAEnterprisePlan,
  updateTeamMembers,
  updateDashboard,
  getDashboardSettings
} from "app/NativeActions";

import Steps from "./Steps";
import CompletedSteps from "./CompletedSteps";
import CompletedStepsEnterprise from "./CompletedStepsEnterprise";

import News from "./News";
import Webinars from "./News/Webinars";
import MonthlyLeadGoal from "./MonthlyLeadGoal";
import ActiveMailersGoal from "./ActiveMailersGoal";
import ActiveLeadSnapshot from "./ActiveLeadSnapshot";

import Analytics from "./Analytics";
class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      is_enterprise: checkIfOnAEnterprisePlan({
        plan_modules: props.plan_modules
      })
    };

    this._scroll_view = React.createRef();
    this.scrollToTop = this.scrollToTop.bind(this);
  }
  componentDidMount() {
    /*mobile*/
    if (this.props.dashboardMobile) {
      this.props.toggleCanPop("");
      this.props.lockDrawer(false);
    }

    this.props.changeTab("dashboard");

    if (parseInt(this.props.user.team_clearance_level) === 0) {
      this.props.appRedirect({ redirect: "map" });
    }
  }

  renderAnalytics() {
    if (
      (this.props.user.completed_dashboard_steps &&
        !this.state.is_enterprise) ||
      (this.props.user.completed_enterprise_steps && this.state.is_enterprise)
    ) {
      return (
        <Row
          style={{
            flexDirection: this.props.dashboardMobile ? "column" : "row"
          }}
        >
          <Wrapper style={{ alignSelf: "stretch", flex: 1 }}>
            <MonthlyLeadGoal
              {...this.props}
              is_enterprise={this.state.is_enterprise}
            />
            <ActiveMailersGoal
              {...this.props}
              is_enterprise={this.state.is_enterprise}
            />
            <ActiveLeadSnapshot
              {...this.props}
              is_enterprise={this.state.is_enterprise}
            />
          </Wrapper>
          <Analytics {...this.props} />
        </Row>
      );
    }
  }

  scrollToTop() {
    if (this.props.device == "mobile") {
      if (this._scroll_view) {
        if (this._scroll_view.current) {
          this._scroll_view.current.scrollToPosition(
            0,
            this.props.platform == "android" ? -40 : 0
          );
        }
      }
    } else {
    }
  }

  render() {
    return (
      <Container includeInfoBanner={true}>
        <Header
          title="Dashboard"
          leftButtonIcon="menu"
          leftButtonAction={
            this.props.device == "desktop"
              ? () => {
                  this.props.mobileToggleDrawer(
                    !this.props.mobile_toggle_drawer
                  );
                }
              : () => this.props.toggleDrawer("open")
          }
          rightButtonIcon={"notifications"}
          rightButtonAction={() =>
            this.props.appRedirect({ redirect: "account_activity" })
          }
          rightButtonIcon2={"date-range"}
          rightButtonAction2={() =>
            this.props.appRedirect({ redirect: "calendar" })
          }
        />
        <KeyboardView style={{ maxWidth: 1200 }} scroll_ref={this._scroll_view}>
          <Wrapper
            style={{
              paddingTop: 0,
              paddingBottom: 20,
              padding: this.props.dashboardMobile ? 0 : 20
            }}
          >
            <Row
              style={{
                flexDirection: this.props.dashboardMobile ? "column" : "row"
              }}
            >
              <Steps
                {...this.props}
                is_enterprise={this.state.is_enterprise}
                scrollToTop={this.scrollToTop}
              />
              <CompletedSteps
                {...this.props}
                is_enterprise={this.state.is_enterprise}
              />
              <CompletedStepsEnterprise
                {...this.props}
                is_enterprise={this.state.is_enterprise}
              />
              <News {...this.props} is_enterprise={this.state.is_enterprise} />
            </Row>
            <Webinars {...this.props} />
            {this.renderAnalytics()}
          </Wrapper>
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, settings, native, billing }) => {
  const { token, user } = auth;
  const {
    colors,
    dashboard_settings_loading,
    properties_added_last_30_days,
    properties_added_last_24_hours,
    dashboard_goals,
    enterprise_goals,
    enterprise_goal_variables,
    active_snapshot
  } = settings;

  const {
    dashboardMobile,
    isMobile,
    device,
    platform,
    mobile_toggle_drawer
  } = native;
  const { plan_modules } = billing;
  return {
    token,
    user,
    dashboardMobile,
    isMobile,
    colors,
    device,
    platform,
    mobile_toggle_drawer,
    plan_modules,
    dashboard_settings_loading,
    properties_added_last_30_days,
    properties_added_last_24_hours,
    dashboard_goals,
    enterprise_goals,
    enterprise_goal_variables,
    active_snapshot
  };
};

export default connect(mapStateToProps, {
  toggleCanPop,
  toggleDrawer,
  lockDrawer,
  mobileToggleDrawer,
  changeTab,
  appRedirect,
  updateDashboard,
  updateTeamMembers,
  getDashboardSettings,
  trackSegmentEvent
})(Dashboard);
